t = require('app/scripts/views/internal/teacup-with-helpers')('power_ups_about_voting')

module.exports = ->
  t.format 'give-power-to-the-people-and-allow-users-to-vote-on-cards-then-track-card-vote-counts-and-voter-list'
